<ng-container *ngIf="!categoryViewModel.currentBigId(); else mini">
  <app-marketing-category [template]="content"
                          [getHome]="false"
                          [showBottomBar]="!!viewModel.waterfall().length"/>
  <ng-template #content>
    <div class="home-container">
      <app-swiper-slides class="full-width"
                         [slides]="viewModel.banners()"
                         [width]="viewModel.detectService.windowWidth()"
                         [allowTouchMove]="false"
                         [aspectRatio]="viewModel.apiResult().banner?.aspectRatio ?? 0"
                         (itemClick)="bannerClick($event)"/>
      <div class="full-width dynamic-block">
        <app-dynamic-block class="full-width"
                           [blocks]="viewModel.apiResult().dynamicBlock?.dynamicBlocks ?? []"
                           [aspectRatio]="viewModel.apiResult().dynamicBlock?.aspectRatio ?? 0"
                           [showTitle]="false"/>
      </div>
      <app-waterfall [columns]="viewModel.waterfall()"
                     [gapSize]="20"
                     (itemClick)="waterFallClick($event)"/>
    </div>
  </ng-template>
</ng-container>
<ng-template #mini>
  <app-mini-home/>
</ng-template>
